import { call, getContext, put, takeLatest } from 'redux-saga/effects';
import BasketAPI from '../../../api/basket/BasketAPI';
import { basketActions } from '../actions/BasketActions.creators';
import { BasketActionTypes } from '../../../enums/ActionEnums';
export function* removeProductFromBasketAnalytics(action) {
    try {
        const { defaultRequestParams, servicesEndpoint } = yield getContext('aemConfiguration');
        const analyticsGoogleTagManagerData = yield call(BasketAPI.removeProductFromBasketAnalytics, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createRemoveGoogleAnalyticsSuccessAction(analyticsGoogleTagManagerData));
        const analyticsAdobeTagManagerData = yield call(BasketAPI.removeProductFromBasketDtm, action.payload.product, servicesEndpoint, defaultRequestParams);
        yield put(basketActions.createRemoveAdobeAnalyticsSuccessAction(analyticsAdobeTagManagerData));
    }
    catch (_a) { }
}
export function* removeProductFromBasketAnalyticsSaga() {
    yield takeLatest(BasketActionTypes.REMOVE_PRODUCT_SUCCESS, removeProductFromBasketAnalytics);
}
